module.exports = __webpack_public_path__ + "img/high-2.ea7bc87b.svg";